import { render, staticRenderFns } from "./EventsPopUp.vue?vue&type=template&id=542452cf&scoped=true"
import script from "./EventsPopUp.vue?vue&type=script&lang=js"
export * from "./EventsPopUp.vue?vue&type=script&lang=js"
import style0 from "./EventsPopUp.vue?vue&type=style&index=0&id=542452cf&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542452cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('542452cf')) {
      api.createRecord('542452cf', component.options)
    } else {
      api.reload('542452cf', component.options)
    }
    module.hot.accept("./EventsPopUp.vue?vue&type=template&id=542452cf&scoped=true", function () {
      api.rerender('542452cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/posts/components/planner/calendar/EventsPopUp.vue"
export default component.exports